import EfScrollAni from '@/efscrollani';

import StatusA from './StatusA';
import './index.scss';

export default function ExampleProductA() {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    return (
        <div className="page-product">
            <StatusA />
        </div>
    );
}
